import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { ApolloService } from '../services/apollo.service';

@Injectable({
  providedIn: 'root',
})
export class ScrubberDataService {
  constructor(private apolloService: ApolloService) { }

  getScrubberData(filter: any) {
    const query = `
        query GetScrubberMonthlyData($filter: ScrubberDataFilter) {
          getScrubberMonthlyData(filter: $filter) {
            success
            statusCode
            message
            hasScrubberFailureinCurrentMonth
            hasScrubberFailureinPreviousMonth
            hasScrubberPointUpdateinCurrentMonth            
            data {
              year
              vslOwner
              vslNumber
              vslName
              vslClass
              vslCodeOwner
              subPool
              scbrPoints
              scbrSavingsAmtYTD
              scbrSavingsAmt
              scbrDaysYTD
              scbrDays
              month
              createdAt
              canSeeShipLevelCalculation
            }
          }
        }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getScrubberLatestMonthYear() {
    const query = `
      query GetScrubberLatestMonthYear {
        getScrubberLatestMonthYear {
          data {
            latestMonth
            latestYear
            lastMonth
            lastYear
            lastUpdatedAt
          }
          success
          statusCode
          message
        }
      }
      `;
    return this.apolloService.query(query).valueChanges
  }

  updatScbrDaysYTD(input: any, month, year) {
    const query = `
      mutation updateScbrDaysYtd($input: [UpdateScbrDaysYtdInput!]!,$month: Int,$year: Int) {
        updateScbrDaysYtd(input: $input,month: $month,year: $year) {
          statusCode
            success
            message
            scbrDaysYtd {
              norUpdated
              scbrDaysYtdUpdated
            }
          }
        }
       `;
    return this.apolloService.mutate(query, { "input": input, "month": month, "year": year })
  }

  getScrubberSavingsData(filter: any) {
    const query = `
    query GetFleetLevelScrubberSavings($filter: SubpoolFleetLevelScrubberSaving) {
  getFleetLevelScrubberSavings(filter: $filter) {
    data {
      scrubberSavingsMonthly
      scrubberSavings
      IFOConsumptionOfPool
      IFOConsumptionOfPoolYTD
      prevYearIFOConsumptionOfPoolYTD
      prevYearIFOCostOfPoolYTD
      IFOCostOfPool
      IFOCostOfPoolYTD
      totalIFOCost
      totalIFOCostYTD
      totalIFOConsumption
      totalIFOConsumptionYTD
    }
    success
    statusCode
    message
  }
}`
    return from(this.apolloService.query(query).refetch({ filter: filter }));

  }

  getScrubberSavingsSidePanelData(filter: any) {
    const query = `
    query GetPoolLevelScrubberSavings($filter: SubpoolPoolLevelScrubberSaving) {
      getPoolLevelScrubberSavings(filter: $filter) {
        poolLevelScrubberSavings {
          poolName
          sequenceNumber
          scrubberSavingsMonthly
          IFOConsumptionOfPool
          prevYearIFOConsumptionOfPoolYTD
          IFOCostOfPool
          prevYearIFOCostOfPoolYTD
          scrubberSavings
          IFOConsumptionOfPoolYTD
          IFOCostOfPoolYTD
        }
        avgBunkerPriceMonthly {
          IFO
          LSF
          MGO
          LNG
          BFB
        }
        bunkerConsumptionMultipliers {
          LSF
          MGO
          LNG
        }
    
        success
        statusCode
        message
      }
    }`
    return from(this.apolloService.query(query).refetch({ filter: filter }));

  }


  getScrubberShipSidePanelData(filter: any) {
    const query = `
    query GetShipLevelScrubberData($filter: ShipLevelScrubberDataFilter) {
      getShipLevelScrubberData(filter: $filter) {
      data {
        scbrDays
        scbrDaysYTD 
        scbrPoints
        scbrSavingsAmt
        scbrSavingsAmtYTD
        distributionWeight
        distributionWeightYTD
        monthlyTotalScrubberSavingsOfFleet
        yearlyTotalScrubberSavingsOfFleet
      }    
      success
      statusCode
      message
      }
    }`
    return from(this.apolloService.query(query).refetch({ filter: filter }));

  }
  getScrubberFailureEvent(filter: any) {
    const query = `
    query GetScrubberFailureEvents($filter: ScrubberFailureFilterInput!) {
    getScrubberFailureEvents(filter: $filter) {
      data {
        serialNo
        delayFrmt
        delayToGmt
        duration
        reason
        remarks
        isRetroActiveAdjustment
      }
      success
      statusCode
      message
    }
    }`
    return from(this.apolloService.query(query).refetch({ filter: filter }));

  }
  getScrubberPointEvent(filter: any) {
    const query = `
    query GetScrubberPointChanges($filter: ScrubberPointChangeFilterInput!) {
      getScrubberPointChanges(filter: $filter) {
        data {
          serialNo
          effectiveDate
          reason
          isRetroActiveAdjustment
        }
        success
        statusCode
        message
      }
    }`
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }
}

